export default __webpack_public_path__ + "static/media/icon-google.97755353.svg";